export default function codegenNativeComponent(name: string, opts?: any) {
  // return a lightweight stub for web builds
  return function WebStub(props: any) { return null; } as any;
}
